import { useGlobalQuery } from '@/state/query-client/hooks';
import { keepPreviousData } from '@tanstack/react-query';
import { getSkillsFor, getSkillTaxonomy } from '../services/skill-lookups.service';

/** Skill categories and sub-categories (managed under Org Setup). */
export const useGetSkillTaxonomy = () => {
  return useGlobalQuery({
    queryKey: ['hr-skill-taxonomy'],
    queryFn: () => getSkillTaxonomy(),
    staleTime: 5 * 60 * 1000,
  });
};

const uniqueSorted = (values: string[]) => [...new Set(values.filter(Boolean))].sort();

export const skillsForQueryOptions = (skillIds: string[], subCategoryIds: string[]) => {
  const ids = uniqueSorted(skillIds);
  const subCategories = uniqueSorted(subCategoryIds);
  return {
    queryKey: ['hr-skills-for', ids, subCategories],
    queryFn: () => getSkillsFor(ids, subCategories),
    staleTime: 5 * 60 * 1000,
  };
};

export const useGetSkillsFor = (skillIds: string[], subCategoryIds: string[], enabled = true) =>
  useGlobalQuery({
    ...skillsForQueryOptions(skillIds, subCategoryIds),
    enabled,
    placeholderData: keepPreviousData,
  });
